import { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { config } from '~common/utils';
import { API } from '@aws-amplify/api';

async function checkEmailExists(email) {
  const path = config.path.getEmailExists;
  const { apiName } = config;

  const res = await API.get(apiName, `${path}?email=${encodeURIComponent(email)}`, { email });
  return res.exists;
}

const UpdateEmailDialog = ({
  open, currentEmail, onClose, onSubmit,
}) => {
  const [newEmail, setNewEmail] = useState(currentEmail || '');
  const [syncOldData, setSyncOldData] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    setNewEmail(currentEmail || '');
    setSyncOldData(false);
    setEmailExists(false);
    setErrorText('');
    setIsChecking(false);
  }, [currentEmail, open]);

  useEffect(() => {
    let handler;
    if (newEmail && newEmail !== currentEmail) {
      handler = setTimeout(() => {
        checkEmailExists(newEmail).then((exists) => {
          setEmailExists(exists);
          setErrorText(exists ? 'Email already exists' : '');
          setIsChecking(false);
        });
      }, 400);
    } else {
      setEmailExists(false);
      setErrorText('');
      setIsChecking(false);
    }
    return () => {
      clearTimeout(handler);
    };
  }, [newEmail, currentEmail]);

  const handleChange = (e) => {
    const val = e.target.value.toLowerCase();
    setNewEmail(val);
    if (val && val !== currentEmail) {
      setIsChecking(true);
      setEmailExists(false);
      setErrorText('');
    } else {
      setIsChecking(false);
      setEmailExists(false);
      setErrorText('');
    }
  };

  const handleCheckboxChange = (e) => {
    setSyncOldData(e.target.checked);
  };

  const handleSubmit = () => {
    onSubmit(newEmail, syncOldData);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Update Email</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter a new email address for this user:
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          label="New Email Address"
          type="email"
          fullWidth
          variant="standard"
          value={newEmail}
          onChange={handleChange}
          error={!!errorText}
          helperText={errorText}
          inputProps={{
            autoComplete: 'new-password',
          }}
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={syncOldData}
              onChange={handleCheckboxChange}
            />
          )}
          label="Sync old data"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} disabled={isChecking || emailExists}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateEmailDialog;
